import React from 'react'
import { Helmet } from 'react-helmet'

import '../css/News.css'

import EHDO from '../assets/img/ehdo.jpg'
import Tent from '../assets/img/tent.jpg'
import Playday from '../assets/img/playday.jpg'
import FeedingProgram from '../assets/img/school-feeding-program.jpg'
import WotatochGenetSchool from '../assets/img/wotatoch-genet-school.jpg'

export default function News() {
  return (
    <div id="news">
      <Helmet>
        <title>News - Enoho Fikir</title>
      </Helmet>

      <h1>News & Updates</h1>

      <div id="cover-stories">
        <div id="pad-donation">
          <img src={ Tent } />
          <a href="/blog/ehdo-donated-feminine-sanitary-pads-to-adwa-ber-female-students">EHDO Donated Feminine Sanitary Pads to Adwa Ber Female Students</a>
        </div>

        <div id="feeding-program">
          <img src={ FeedingProgram } />
          <a href="/blog/ehdo-launched-a-school-feeding-program">EHDO launched a School Feeding Program</a>
        </div>

        <div id="school-update">
          <img src={ WotatochGenetSchool } />
          <a href="/blog/ehdo-founding-members-sisited-adwa-ber-and-wotatoch-genet-schools">EHDO Founding Members Visited Adwa Ber and Wotatoch Genet Schools</a>
        </div>
      </div>

      <h2>Latest News <i className="arrow-right"></i></h2>
      <div id="latest-news">
        <div>
          <a href="/blog/ehdo-organized-a-playday-at-adwa-ber-school">
            <img src={ Playday } />
            <h2>EDHO Organized a Playday at Adwa Ber School</h2>
            <p>One of the objectives of EDHO is to render a psychosocial support to the children that are included in the school feeding program. Hence, a program that was aimed at bringing closer relationship bonding amongst the students, the school community, the...</p>
          </a>
        </div>

        <div>
          <a href="/blog/ehdo-participated-in-the-sene-30-school-program">
            <img src={ EHDO } />
            <h2>EHDO Participated in the Sene 30 School Program</h2>
            <p>EHDO gave rewards to high academic achiever students and best performer teachers at Adwa Ber Shool. Students that ranked from 1st to 3rd were presented with rewards for their hard work and accomplishment. This is believed to be a motivating factor t...</p>
          </a>
        </div>
      </div>
    </div>
  )
}